// Chakra imports
import { Flex, Text, useColorModeValue, Badge } from '@chakra-ui/react';
import IconBoxLink from 'components/icons/IconBox';
import { MdDrafts } from 'react-icons/md';


export default function IncomingOrder(props: { date: string; status: string; name: string; [x: string]: any, orderDocumentLink: string }) {
	const { date, status, name, orderDocumentLink, ...rest } = props;
	const iconBoxBg = useColorModeValue('secondaryGray.300', 'grey');
	const textColor = useColorModeValue('secondaryGray.900', 'white');
	const lowerStatus = status.toLowerCase();
	return (
		<Flex justifyContent='center' alignItems='center' w='100%' {...rest}>
			<IconBoxLink h='42px' w='42px' bg={iconBoxBg} me='20px' icon={<MdDrafts />} link={orderDocumentLink} />
			<Flex direction='column' align='start' me='auto'>
				<Text color={textColor} fontSize='md' me='6px' fontWeight='700'>
					{name} 
				</Text>
				<Text color='secondaryGray.600' fontSize='sm' fontWeight='500'>
					Arrival: {date}
				</Text>
			</Flex>
			<Badge
				ms='auto'
				colorScheme={lowerStatus === 'due'
					 ? 'yellow'
					 : lowerStatus === 'pending'
					 ? 'yellow'
					 : lowerStatus ===  'received'
					 ? 'green'
					 : lowerStatus ===  'overdue'
					 ? 'red'
					 : lowerStatus ===  'cancelled'
					 ? 'grey'
					 : 'green'
					}
				color={lowerStatus === 'due'
					? 'yellow.500'
					: lowerStatus ===  'pending'
					? 'yellow.500'
					: lowerStatus ===  'received'
					? 'green.500'
					: lowerStatus ===  'overdue'
					? 'red.500'
					: lowerStatus ===  'cancelled'
					? 'grey.500'
					: 'green.500'}
				fontSize='sm'>
				{status}
			</Badge>
			
		</Flex>
	);
}
